import { ImageViewer, ImageViewerContent } from "./beui/ImageViewer";
import type { LightboxImage } from "./ImageLightbox";

export function ServicePhotoViewer({ images, initialIndex, onClose }: { images: LightboxImage[]; initialIndex: number; onClose: () => void }) {
  return <ImageViewer images={images.map((image, index) => ({ id: String(index), ...image }))} defaultValue={String(initialIndex)} label="Service photos" onValueChange={value => { if (value === null) onClose(); }}><ImageViewerContent /></ImageViewer>;
}
